import React from "react";

type TIconeName = {
  iconName: string;
  fill?: string;
  nameClass?: string;
  handleClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
};

const IconSVG: React.FC<TIconeName> = ({ iconName, fill, nameClass, handleClick }) => {
  const renderIcon = (iconName: string) => {
    switch (iconName) {
      case "homeActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M22.58 7.35L12.475 1.897c-.297-.16-.654-.16-.95 0L1.425 7.35c-.486.264-.667.87-.405 1.356.18.335.525.525.88.525.16 0 .324-.038.475-.12l.734-.396 1.59 11.25c.216 1.214 1.31 2.062 2.66 2.062h9.282c1.35 0 2.444-.848 2.662-2.088l1.588-11.225.737.398c.485.263 1.092.082 1.354-.404.263-.486.08-1.093-.404-1.355zM12 15.435c-1.795 0-3.25-1.455-3.25-3.25s1.455-3.25 3.25-3.25 3.25 1.455 3.25 3.25-1.455 3.25-3.25 3.25z"
              ></path>
            </g>
          </svg>
        );
      case "home":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M22.46 7.57L12.357 2.115c-.223-.12-.49-.12-.713 0L1.543 7.57c-.364.197-.5.652-.303 1.017.135.25.394.393.66.393.12 0 .243-.03.356-.09l.815-.44L4.7 19.963c.214 1.215 1.308 2.062 2.658 2.062h9.282c1.352 0 2.445-.848 2.663-2.087l1.626-11.49.818.442c.364.193.82.06 1.017-.304.196-.363.06-.818-.304-1.016zm-4.638 12.133c-.107.606-.703.822-1.18.822H7.36c-.48 0-1.075-.216-1.178-.798L4.48 7.69 12 3.628l7.522 4.06-1.7 12.015z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M8.22 12.184c0 2.084 1.695 3.78 3.78 3.78s3.78-1.696 3.78-3.78-1.695-3.78-3.78-3.78-3.78 1.696-3.78 3.78zm6.06 0c0 1.258-1.022 2.28-2.28 2.28s-2.28-1.022-2.28-2.28 1.022-2.28 2.28-2.28 2.28 1.022 2.28 2.28z"
              ></path>
            </g>
          </svg>
        );
      case "exploreActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M22.06 19.94l-3.73-3.73C19.38 14.737 20 12.942 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c1.943 0 3.738-.622 5.21-1.67l3.73 3.73c.292.294.676.44 1.06.44s.768-.146 1.06-.44c.586-.585.586-1.535 0-2.12zM11 17c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
              ></path>
            </g>
          </svg>
        );
      case "explore":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"
              ></path>
            </g>
          </svg>
        );
      case "notificationActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M21.697 16.468c-.02-.016-2.14-1.64-2.103-6.03.02-2.533-.812-4.782-2.347-6.334-1.375-1.393-3.237-2.164-5.242-2.172h-.013c-2.004.008-3.866.78-5.242 2.172-1.534 1.553-2.367 3.802-2.346 6.333.037 4.332-2.02 5.967-2.102 6.03-.26.194-.366.53-.265.838s.39.515.713.515h4.494c.1 2.544 2.188 4.587 4.756 4.587s4.655-2.043 4.756-4.587h4.494c.324 0 .61-.208.712-.515s-.005-.644-.265-.837zM12 20.408c-1.466 0-2.657-1.147-2.756-2.588h5.512c-.1 1.44-1.29 2.587-2.756 2.587z"
              ></path>
            </g>
          </svg>
        );
      case "notification":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M21.697 16.468c-.02-.016-2.14-1.64-2.103-6.03.02-2.532-.812-4.782-2.347-6.335C15.872 2.71 14.01 1.94 12.005 1.93h-.013c-2.004.01-3.866.78-5.242 2.174-1.534 1.553-2.368 3.802-2.346 6.334.037 4.33-2.02 5.967-2.102 6.03-.26.193-.366.53-.265.838.102.308.39.515.712.515h4.92c.102 2.31 1.997 4.16 4.33 4.16s4.226-1.85 4.327-4.16h4.922c.322 0 .61-.206.71-.514.103-.307-.003-.645-.263-.838zM12 20.478c-1.505 0-2.73-1.177-2.828-2.658h5.656c-.1 1.48-1.323 2.66-2.828 2.66zM4.38 16.32c.74-1.132 1.548-3.028 1.524-5.896-.018-2.16.644-3.982 1.913-5.267C8.91 4.05 10.397 3.437 12 3.43c1.603.008 3.087.62 4.18 1.728 1.27 1.285 1.933 3.106 1.915 5.267-.024 2.868.785 4.765 1.525 5.896H4.38z"
              ></path>
            </g>
          </svg>
        );
      case "messageActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M11.55 12.082c.273.182.627.182.9 0L22 5.716V5.5c0-1.24-1.01-2.25-2.25-2.25H4.25C3.01 3.25 2 4.26 2 5.5v.197l9.55 6.385z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M13.26 13.295c-.383.255-.82.382-1.26.382s-.877-.127-1.26-.383L2 7.452v11.67c0 1.24 1.01 2.25 2.25 2.25h15.5c1.24 0 2.25-1.01 2.25-2.25V7.47l-8.74 5.823z"
              ></path>
            </g>
          </svg>
        );
      case "message":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.25 3.018H4.75C3.233 3.018 2 4.252 2 5.77v12.495c0 1.518 1.233 2.753 2.75 2.753h14.5c1.517 0 2.75-1.235 2.75-2.753V5.77c0-1.518-1.233-2.752-2.75-2.752zm-14.5 1.5h14.5c.69 0 1.25.56 1.25 1.25v.714l-8.05 5.367c-.273.18-.626.182-.9-.002L3.5 6.482v-.714c0-.69.56-1.25 1.25-1.25zm14.5 14.998H4.75c-.69 0-1.25-.56-1.25-1.25V8.24l7.24 4.83c.383.256.822.384 1.26.384.44 0 .877-.128 1.26-.383l7.24-4.83v10.022c0 .69-.56 1.25-1.25 1.25z"
              ></path>
            </g>
          </svg>
        );
      case "bookmarkActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.9 23.5c-.2 0-.3 0-.4-.1L12 17.9l-7.5 5.4c-.2.2-.5.2-.8.1-.2-.1-.4-.4-.4-.7V5.6c0-1.2 1-2.2 2.2-2.2h12.8c1.2 0 2.2 1 2.2 2.2v17.1c0 .3-.2.5-.4.7 0 .1-.1.1-.2.1z"
              ></path>
            </g>
          </svg>
        );
      case "bookmark":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.9 23.5c-.157 0-.312-.05-.442-.144L12 17.928l-7.458 5.43c-.228.164-.53.19-.782.06-.25-.127-.41-.385-.41-.667V5.6c0-1.24 1.01-2.25 2.25-2.25h12.798c1.24 0 2.25 1.01 2.25 2.25v17.15c0 .282-.158.54-.41.668-.106.055-.223.082-.34.082zM12 16.25c.155 0 .31.048.44.144l6.71 4.883V5.6c0-.412-.337-.75-.75-.75H5.6c-.413 0-.75.338-.75.75v15.677l6.71-4.883c.13-.096.285-.144.44-.144z"
              ></path>
            </g>
          </svg>
        );
      case "listActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.75 2H4.25C3.013 2 2 3.013 2 4.25v15.5C2 20.987 3.013 22 4.25 22h15.5c1.237 0 2.25-1.013 2.25-2.25V4.25C22 3.013 20.987 2 19.75 2zM11 16.75H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4c.414 0 .75.336.75.75s-.336.75-.75.75zm6-4H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75zm0-4H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "list":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.75 22H4.25C3.01 22 2 20.99 2 19.75V4.25C2 3.01 3.01 2 4.25 2h15.5C20.99 2 22 3.01 22 4.25v15.5c0 1.24-1.01 2.25-2.25 2.25zM4.25 3.5c-.414 0-.75.337-.75.75v15.5c0 .413.336.75.75.75h15.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75H4.25z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M17 8.64H7c-.414 0-.75-.337-.75-.75s.336-.75.75-.75h10c.414 0 .75.335.75.75s-.336.75-.75.75zm0 4.11H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75zm-5 4.11H7c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h5c.414 0 .75.337.75.75s-.336.75-.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "profileActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12.225 12.165c-1.356 0-2.872-.15-3.84-1.256-.814-.93-1.077-2.368-.805-4.392.38-2.826 2.116-4.513 4.646-4.513s4.267 1.687 4.646 4.513c.272 2.024.008 3.46-.806 4.392-.97 1.106-2.485 1.255-3.84 1.255zm5.849 9.85H6.376c-.663 0-1.25-.28-1.65-.786-.422-.534-.576-1.27-.41-1.968.834-3.53 4.086-5.997 7.908-5.997s7.074 2.466 7.91 5.997c.164.698.01 1.434-.412 1.967-.4.505-.985.785-1.648.785z"
              ></path>
            </g>
          </svg>
        );
      case "profile":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 11.816c1.355 0 2.872-.15 3.84-1.256.814-.93 1.078-2.368.806-4.392-.38-2.825-2.117-4.512-4.646-4.512S7.734 3.343 7.354 6.17c-.272 2.022-.008 3.46.806 4.39.968 1.107 2.485 1.256 3.84 1.256zM8.84 6.368c.162-1.2.787-3.212 3.16-3.212s2.998 2.013 3.16 3.212c.207 1.55.057 2.627-.45 3.205-.455.52-1.266.743-2.71.743s-2.255-.223-2.71-.743c-.507-.578-.657-1.656-.45-3.205zm11.44 12.868c-.877-3.526-4.282-5.99-8.28-5.99s-7.403 2.464-8.28 5.99c-.172.692-.028 1.4.395 1.94.408.52 1.04.82 1.733.82h12.304c.693 0 1.325-.3 1.733-.82.424-.54.567-1.247.394-1.94zm-1.576 1.016c-.126.16-.316.246-.552.246H5.848c-.235 0-.426-.085-.552-.246-.137-.174-.18-.412-.12-.654.71-2.855 3.517-4.85 6.824-4.85s6.114 1.994 6.824 4.85c.06.242.017.48-.12.654z"
              ></path>
            </g>
          </svg>
        );
      case "more":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <circle fill={fill ? fill : "#f1f1f1"} cx="17" cy="12" r="1.5"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="12" cy="12" r="1.5"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="7" cy="12" r="1.5"></circle>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12S6.072 1.25 12 1.25 22.75 6.072 22.75 12 17.928 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
              ></path>
            </g>
          </svg>
        );
      case "add-tweet":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M8.8 7.2H5.6V3.9c0-.4-.3-.8-.8-.8s-.7.4-.7.8v3.3H.8c-.4 0-.8.3-.8.8s.3.8.8.8h3.3v3.3c0 .4.3.8.8.8s.8-.3.8-.8V8.7H9c.4 0 .8-.3.8-.8s-.5-.7-1-.7zm15-4.9v-.1h-.1c-.1 0-9.2 1.2-14.4 11.7-3.8 7.6-3.6 9.9-3.3 9.9.3.1 3.4-6.5 6.7-9.2 5.2-1.1 6.6-3.6 6.6-3.6s-1.5.2-2.1.2c-.8 0-1.4-.2-1.7-.3 1.3-1.2 2.4-1.5 3.5-1.7.9-.2 1.8-.4 3-1.2 2.2-1.6 1.9-5.5 1.8-5.7z"
              ></path>
            </g>
          </svg>
        );
      case "3-dot":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <circle fill={fill ? fill : "#f1f1f1"} cx="17" cy="12" r="1.5"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="12" cy="12" r="1.5"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="7" cy="12" r="1.5"></circle>
            </g>
          </svg>
        );
      case "etoil":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M22.772 10.506l-5.618-2.192-2.16-6.5c-.102-.307-.39-.514-.712-.514s-.61.207-.712.513l-2.16 6.5-5.62 2.192c-.287.112-.477.39-.477.7s.19.585.478.698l5.62 2.192 2.16 6.5c.102.306.39.513.712.513s.61-.207.712-.513l2.16-6.5 5.62-2.192c.287-.112.477-.39.477-.7s-.19-.585-.478-.697zm-6.49 2.32c-.208.08-.37.25-.44.46l-1.56 4.695-1.56-4.693c-.07-.21-.23-.38-.438-.462l-4.155-1.62 4.154-1.622c.208-.08.37-.25.44-.462l1.56-4.693 1.56 4.694c.07.212.23.382.438.463l4.155 1.62-4.155 1.622zM6.663 3.812h-1.88V2.05c0-.414-.337-.75-.75-.75s-.75.336-.75.75v1.762H1.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.782v1.762c0 .414.336.75.75.75s.75-.336.75-.75V5.312h1.88c.415 0 .75-.336.75-.75s-.335-.75-.75-.75zm2.535 15.622h-1.1v-1.016c0-.414-.335-.75-.75-.75s-.75.336-.75.75v1.016H5.57c-.414 0-.75.336-.75.75s.336.75.75.75H6.6v1.016c0 .414.335.75.75.75s.75-.336.75-.75v-1.016h1.098c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"
              ></path>
            </g>
          </svg>
        );
      case "settings":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 8.21c-2.09 0-3.79 1.7-3.79 3.79s1.7 3.79 3.79 3.79 3.79-1.7 3.79-3.79-1.7-3.79-3.79-3.79zm0 6.08c-1.262 0-2.29-1.026-2.29-2.29S10.74 9.71 12 9.71s2.29 1.026 2.29 2.29-1.028 2.29-2.29 2.29z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12.36 22.375h-.722c-1.183 0-2.154-.888-2.262-2.064l-.014-.147c-.025-.287-.207-.533-.472-.644-.286-.12-.582-.065-.798.115l-.116.097c-.868.725-2.253.663-3.06-.14l-.51-.51c-.836-.84-.896-2.154-.14-3.06l.098-.118c.186-.222.23-.523.122-.787-.11-.272-.358-.454-.646-.48l-.15-.014c-1.18-.107-2.067-1.08-2.067-2.262v-.722c0-1.183.888-2.154 2.064-2.262l.156-.014c.285-.025.53-.207.642-.473.11-.27.065-.573-.12-.795l-.094-.116c-.757-.908-.698-2.223.137-3.06l.512-.512c.804-.804 2.188-.865 3.06-.14l.116.098c.218.184.528.23.79.122.27-.112.452-.358.477-.643l.014-.153c.107-1.18 1.08-2.066 2.262-2.066h.722c1.183 0 2.154.888 2.262 2.064l.014.156c.025.285.206.53.472.64.277.117.58.062.794-.117l.12-.102c.867-.723 2.254-.662 3.06.14l.51.512c.836.838.896 2.153.14 3.06l-.1.118c-.188.22-.234.522-.123.788.112.27.36.45.646.478l.152.014c1.18.107 2.067 1.08 2.067 2.262v.723c0 1.183-.888 2.154-2.064 2.262l-.155.014c-.284.024-.53.205-.64.47-.113.272-.067.574.117.795l.1.12c.756.905.696 2.22-.14 3.06l-.51.51c-.807.804-2.19.864-3.06.14l-.115-.096c-.217-.183-.53-.23-.79-.122-.273.114-.455.36-.48.646l-.014.15c-.107 1.173-1.08 2.06-2.262 2.06zm-3.773-4.42c.3 0 .593.06.87.175.79.328 1.324 1.054 1.4 1.896l.014.147c.037.4.367.7.77.7h.722c.4 0 .73-.3.768-.7l.014-.148c.076-.842.61-1.567 1.392-1.892.793-.33 1.696-.182 2.333.35l.113.094c.178.148.366.18.493.18.206 0 .4-.08.546-.227l.51-.51c.284-.284.305-.73.048-1.038l-.1-.12c-.542-.65-.677-1.54-.352-2.323.326-.79 1.052-1.32 1.894-1.397l.155-.014c.397-.037.7-.367.7-.77v-.722c0-.4-.303-.73-.702-.768l-.152-.014c-.846-.078-1.57-.61-1.895-1.393-.326-.788-.19-1.678.353-2.327l.1-.118c.257-.31.236-.756-.048-1.04l-.51-.51c-.146-.147-.34-.227-.546-.227-.127 0-.315.032-.492.18l-.12.1c-.634.528-1.55.67-2.322.354-.788-.327-1.32-1.052-1.397-1.896l-.014-.155c-.035-.397-.365-.7-.767-.7h-.723c-.4 0-.73.303-.768.702l-.014.152c-.076.843-.608 1.568-1.39 1.893-.787.326-1.693.183-2.33-.35l-.118-.096c-.18-.15-.368-.18-.495-.18-.206 0-.4.08-.546.226l-.512.51c-.282.284-.303.73-.046 1.038l.1.118c.54.653.677 1.544.352 2.325-.327.788-1.052 1.32-1.895 1.397l-.156.014c-.397.037-.7.367-.7.77v.722c0 .4.303.73.702.768l.15.014c.848.078 1.573.612 1.897 1.396.325.786.19 1.675-.353 2.325l-.096.115c-.26.31-.238.756.046 1.04l.51.51c.146.147.34.227.546.227.127 0 .315-.03.492-.18l.116-.096c.406-.336.923-.524 1.453-.524z"
              ></path>
            </g>
          </svg>
        );
      case "msg":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M23.25 3.25h-2.425V.825c0-.414-.336-.75-.75-.75s-.75.336-.75.75V3.25H16.9c-.414 0-.75.336-.75.75s.336.75.75.75h2.425v2.425c0 .414.336.75.75.75s.75-.336.75-.75V4.75h2.425c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm-3.175 6.876c-.414 0-.75.336-.75.75v8.078c0 .414-.337.75-.75.75H4.095c-.412 0-.75-.336-.75-.75V8.298l6.778 4.518c.368.246.79.37 1.213.37.422 0 .844-.124 1.212-.37l4.53-3.013c.336-.223.428-.676.204-1.012-.223-.332-.675-.425-1.012-.2l-4.53 3.014c-.246.162-.563.163-.808 0l-7.586-5.06V5.5c0-.414.337-.75.75-.75h9.094c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H4.096c-1.24 0-2.25 1.01-2.25 2.25v13.455c0 1.24 1.01 2.25 2.25 2.25h14.48c1.24 0 2.25-1.01 2.25-2.25v-8.078c0-.415-.337-.75-.75-.75z"
              ></path>
            </g>
          </svg>
        );
      case "lists-plus":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M23.25 3.25h-2.425V.825c0-.414-.336-.75-.75-.75s-.75.336-.75.75V3.25H16.9c-.414 0-.75.336-.75.75s.336.75.75.75h2.425v2.425c0 .414.336.75.75.75s.75-.336.75-.75V4.75h2.425c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zM18.575 22H4.25C3.01 22 2 20.99 2 19.75V5.5c0-1.24 1.01-2.25 2.25-2.25h8.947c.414 0 .75.336.75.75s-.336.75-.75.75H4.25c-.413 0-.75.336-.75.75v14.25c0 .414.337.75.75.75h14.325c.413 0 .75-.336.75-.75v-8.872c0-.414.336-.75.75-.75s.75.336.75.75v8.872c0 1.24-1.01 2.25-2.25 2.25z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M16.078 9.583H6.673c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.405c.414 0 .75.336.75.75s-.336.75-.75.75zm0 3.867H6.673c-.414 0-.75-.337-.75-.75s.336-.75.75-.75h9.405c.414 0 .75.335.75.75s-.336.75-.75.75zm-4.703 3.866H6.673c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.702c.414 0 .75.336.75.75s-.336.75-.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "back":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
            fill={fill ? fill : "#f1f1f1"}
          >
            <g>
              <path d="M20 11H7.414l4.293-4.293c.39-.39.39-1.023 0-1.414s-1.023-.39-1.414 0l-6 6c-.39.39-.39 1.023 0 1.414l6 6c.195.195.45.293.707.293s.512-.098.707-.293c.39-.39.39-1.023 0-1.414L7.414 13H20c.553 0 1-.447 1-1s-.447-1-1-1z"></path>
            </g>
          </svg>
        );
      case "htagActive":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M20.585 9.468c.66 0 1.2-.538 1.2-1.2 0-.662-.54-1.2-1.2-1.2h-3.22l.31-3.547c.027-.318-.07-.63-.277-.875-.206-.245-.495-.396-.822-.425-.65-.035-1.235.432-1.293 1.093l-.326 3.754H9.9l.308-3.545c.06-.658-.43-1.242-1.097-1.302-.665-.05-1.235.43-1.293 1.092l-.325 3.754h-3.33c-.663 0-1.2.538-1.2 1.2 0 .662.538 1.2 1.2 1.2h3.122l-.44 5.064H3.416c-.662 0-1.2.54-1.2 1.2s.538 1.202 1.2 1.202h3.22l-.31 3.548c-.057.657.432 1.24 1.09 1.3l.106.005c.626 0 1.14-.472 1.195-1.098l.327-3.753H14.1l-.308 3.544c-.06.658.43 1.242 1.09 1.302l.106.005c.617 0 1.142-.482 1.195-1.098l.325-3.753h3.33c.66 0 1.2-.54 1.2-1.2s-.54-1.202-1.2-1.202h-3.122l.44-5.064h3.43zm-5.838 0l-.44 5.063H9.253l.44-5.062h5.055z"
              ></path>
            </g>
          </svg>
        );
      case "htag":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M21 7.337h-3.93l.372-4.272c.036-.412-.27-.775-.682-.812-.417-.03-.776.27-.812.683l-.383 4.4h-6.32l.37-4.27c.037-.413-.27-.776-.68-.813-.42-.03-.777.27-.813.683l-.382 4.4H3.782c-.414 0-.75.337-.75.75s.336.75.75.75H7.61l-.55 6.327H3c-.414 0-.75.336-.75.75s.336.75.75.75h3.93l-.372 4.272c-.036.412.27.775.682.812l.066.003c.385 0 .712-.295.746-.686l.383-4.4h6.32l-.37 4.27c-.036.413.27.776.682.813l.066.003c.385 0 .712-.295.746-.686l.382-4.4h3.957c.413 0 .75-.337.75-.75s-.337-.75-.75-.75H16.39l.55-6.327H21c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm-6.115 7.826h-6.32l.55-6.326h6.32l-.55 6.326z"
              ></path>
            </g>
          </svg>
        );
      case "add-post-img":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.75 2H4.25C3.01 2 2 3.01 2 4.25v15.5C2 20.99 3.01 22 4.25 22h15.5c1.24 0 2.25-1.01 2.25-2.25V4.25C22 3.01 20.99 2 19.75 2zM4.25 3.5h15.5c.413 0 .75.337.75.75v9.676l-3.858-3.858c-.14-.14-.33-.22-.53-.22h-.003c-.2 0-.393.08-.532.224l-4.317 4.384-1.813-1.806c-.14-.14-.33-.22-.53-.22-.193-.03-.395.08-.535.227L3.5 17.642V4.25c0-.413.337-.75.75-.75zm-.744 16.28l5.418-5.534 6.282 6.254H4.25c-.402 0-.727-.322-.744-.72zm16.244.72h-2.42l-5.007-4.987 3.792-3.85 4.385 4.384v3.703c0 .413-.337.75-.75.75z"
              ></path>
              <circle fill={fill ? fill : "#f1f1f1"} cx="8.868" cy="8.309" r="1.542"></circle>
            </g>
          </svg>
        );
      case "gif":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19 10.5V8.8h-4.4v6.4h1.7v-2h2v-1.7h-2v-1H19zm-7.3-1.7h1.7v6.4h-1.7V8.8zm-3.6 1.6c.4 0 .9.2 1.2.5l1.2-1C9.9 9.2 9 8.8 8.1 8.8c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2c1 0 1.8-.4 2.4-1.1v-2.5H7.7v1.2h1.2v.6c-.2.1-.5.2-.8.2-.9 0-1.6-.7-1.6-1.6 0-.8.7-1.6 1.6-1.6z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M20.5 2.02h-17c-1.24 0-2.25 1.007-2.25 2.247v15.507c0 1.238 1.01 2.246 2.25 2.246h17c1.24 0 2.25-1.008 2.25-2.246V4.267c0-1.24-1.01-2.247-2.25-2.247zm.75 17.754c0 .41-.336.746-.75.746h-17c-.414 0-.75-.336-.75-.746V4.267c0-.412.336-.747.75-.747h17c.414 0 .75.335.75.747v15.507z"
              ></path>
            </g>
          </svg>
        );
      case "pol":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M20.222 9.16h-1.334c.015-.09.028-.182.028-.277V6.57c0-.98-.797-1.777-1.778-1.777H3.5V3.358c0-.414-.336-.75-.75-.75s-.75.336-.75.75V20.83c0 .415.336.75.75.75s.75-.335.75-.75v-1.434h10.556c.98 0 1.778-.797 1.778-1.777v-2.313c0-.095-.014-.187-.028-.278h4.417c.98 0 1.778-.798 1.778-1.778v-2.31c0-.983-.797-1.78-1.778-1.78zM17.14 6.293c.152 0 .277.124.277.277v2.31c0 .154-.125.28-.278.28H3.5V6.29h13.64zm-2.807 9.014v2.312c0 .153-.125.277-.278.277H3.5v-2.868h10.556c.153 0 .277.126.277.28zM20.5 13.25c0 .153-.125.277-.278.277H3.5V10.66h16.722c.153 0 .278.124.278.277v2.313z"
              ></path>
            </g>
          </svg>
        );
      case "emoji":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12S6.072 1.25 12 1.25 22.75 6.072 22.75 12 17.928 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 17.115c-1.892 0-3.633-.95-4.656-2.544-.224-.348-.123-.81.226-1.035.348-.226.812-.124 1.036.226.747 1.162 2.016 1.855 3.395 1.855s2.648-.693 3.396-1.854c.224-.35.688-.45 1.036-.225.35.224.45.688.226 1.036-1.025 1.594-2.766 2.545-4.658 2.545z"
              ></path>
              <circle fill={fill ? fill : "#f1f1f1"} cx="14.738" cy="9.458" r="1.478"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="9.262" cy="9.458" r="1.478"></circle>
            </g>
          </svg>
        );
      case "schedule":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path fill={fill ? fill : "#f1f1f1"} d="M-37.9 18c-.1-.1-.1-.1-.1-.2.1 0 .1.1.1.2z"></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M-37.9 18c-.1-.1-.1-.1-.1-.2.1 0 .1.1.1.2zM18 2.2h-1.3v-.3c0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8v.3H7.7v-.3c0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8v.3H4.8c-1.4 0-2.5 1.1-2.5 2.5v13.1c0 1.4 1.1 2.5 2.5 2.5h2.9c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8H4.8c-.6 0-1-.5-1-1V7.9c0-.3.4-.7 1-.7H18c.6 0 1 .4 1 .7v1.8c0 .4.3.8.8.8.4 0 .8-.3.8-.8v-5c-.1-1.4-1.2-2.5-2.6-2.5zm1 3.7c-.3-.1-.7-.2-1-.2H4.8c-.4 0-.7.1-1 .2V4.7c0-.6.5-1 1-1h1.3v.5c0 .4.3.8.8.8.4 0 .8-.3.8-.8v-.5h7.5v.5c0 .4.3.8.8.8.4 0 .8-.3.8-.8v-.5H18c.6 0 1 .5 1 1v1.2z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M15.5 10.4c-3.4 0-6.2 2.8-6.2 6.2 0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2 0-3.4-2.8-6.2-6.2-6.2zm0 11c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7 4.7 2.1 4.7 4.7c0 2.5-2.1 4.7-4.7 4.7z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M18.9 18.7c-.1.2-.4.4-.6.4-.1 0-.3 0-.4-.1l-3.1-2v-3c0-.4.3-.8.8-.8.4 0 .8.3.8.8v2.2l2.4 1.5c.2.2.3.6.1 1z"
              ></path>
            </g>
          </svg>
        );
      case "lieu":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 14.315c-2.088 0-3.787-1.698-3.787-3.786S9.913 6.74 12 6.74s3.787 1.7 3.787 3.787-1.7 3.785-3.787 3.785zm0-6.073c-1.26 0-2.287 1.026-2.287 2.287S10.74 12.814 12 12.814s2.287-1.025 2.287-2.286S13.26 8.24 12 8.24z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M20.692 10.69C20.692 5.9 16.792 2 12 2s-8.692 3.9-8.692 8.69c0 1.902.603 3.708 1.743 5.223l.003-.002.007.015c1.628 2.07 6.278 5.757 6.475 5.912.138.11.302.163.465.163.163 0 .327-.053.465-.162.197-.155 4.847-3.84 6.475-5.912l.007-.014.002.002c1.14-1.516 1.742-3.32 1.742-5.223zM12 20.29c-1.224-.99-4.52-3.715-5.756-5.285-.94-1.25-1.436-2.742-1.436-4.312C4.808 6.727 8.035 3.5 12 3.5s7.192 3.226 7.192 7.19c0 1.57-.497 3.062-1.436 4.313-1.236 1.57-4.532 4.294-5.756 5.285z"
              ></path>
            </g>
          </svg>
        );
      case "reply":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z"
              ></path>
            </g>
          </svg>
        );
      case "retweet":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z"
              ></path>
            </g>
          </svg>
        );
      case "unLike":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z"
              ></path>
            </g>
          </svg>
        );
      case "like":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12z"
              ></path>
            </g>
          </svg>
        );
      case "share":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M17.53 7.47l-5-5c-.293-.293-.768-.293-1.06 0l-5 5c-.294.293-.294.768 0 1.06s.767.294 1.06 0l3.72-3.72V15c0 .414.336.75.75.75s.75-.336.75-.75V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22c.293-.293.293-.767 0-1.06z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.708 21.944H4.292C3.028 21.944 2 20.916 2 19.652V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 1.264-1.028 2.292-2.292 2.292z"
              ></path>
            </g>
          </svg>
        );
      case "calendar":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.708 2H4.292C3.028 2 2 3.028 2 4.292v15.416C2 20.972 3.028 22 4.292 22h15.416C20.972 22 22 20.972 22 19.708V4.292C22 3.028 20.972 2 19.708 2zm.792 17.708c0 .437-.355.792-.792.792H4.292c-.437 0-.792-.355-.792-.792V6.418c0-.437.354-.79.79-.792h15.42c.436 0 .79.355.79.79V19.71z"
              ></path>
              <circle fill={fill ? fill : "#f1f1f1"} cx="7.032" cy="8.75" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="7.032" cy="13.156" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="16.968" cy="8.75" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="16.968" cy="13.156" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="12" cy="8.75" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="12" cy="13.156" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="7.032" cy="17.486" r="1.285"></circle>
              <circle fill={fill ? fill : "#f1f1f1"} cx="12" cy="17.486" r="1.285"></circle>
            </g>
          </svg>
        );
      case "icon-notif-add":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M22.99 11.295l-6.986-2.13-.877-.326-.325-.88L12.67.975c-.092-.303-.372-.51-.688-.51-.316 0-.596.207-.688.51l-2.392 7.84-1.774.657-6.148 1.82c-.306.092-.515.372-.515.69 0 .32.21.6.515.69l7.956 2.358 2.356 7.956c.09.306.37.515.69.515.32 0 .6-.21.69-.514l1.822-6.15.656-1.773 7.84-2.392c.303-.09.51-.37.51-.687 0-.316-.207-.596-.51-.688z"
              ></path>
            </g>
          </svg>
        );
      case "camImage":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.708 22H4.292C3.028 22 2 20.972 2 19.708V7.375C2 6.11 3.028 5.083 4.292 5.083h2.146C7.633 3.17 9.722 2 12 2c2.277 0 4.367 1.17 5.562 3.083h2.146C20.972 5.083 22 6.11 22 7.375v12.333C22 20.972 20.972 22 19.708 22zM4.292 6.583c-.437 0-.792.355-.792.792v12.333c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V7.375c0-.437-.355-.792-.792-.792h-2.45c-.317.05-.632-.095-.782-.382-.88-1.665-2.594-2.7-4.476-2.7-1.883 0-3.598 1.035-4.476 2.702-.16.302-.502.46-.833.38H4.293z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 8.167c-2.68 0-4.86 2.18-4.86 4.86s2.18 4.86 4.86 4.86 4.86-2.18 4.86-4.86-2.18-4.86-4.86-4.86zm2 5.583h-1.25V15c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.25H10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25V11c0-.414.336-.75.75-.75s.75.336.75.75v1.25H14c.414 0 .75.336.75.75s-.336.75-.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "ok":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M9 20c-.264 0-.52-.104-.707-.293l-4.785-4.785c-.39-.39-.39-1.023 0-1.414s1.023-.39 1.414 0l3.946 3.945L18.075 4.41c.32-.45.94-.558 1.395-.24.45.318.56.942.24 1.394L9.817 19.577c-.17.24-.438.395-.732.42-.028.002-.057.003-.085.003z"
              ></path>
            </g>
          </svg>
        );
      case "close":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M13.414 12l5.793-5.793c.39-.39.39-1.023 0-1.414s-1.023-.39-1.414 0L12 10.586 6.207 4.793c-.39-.39-1.023-.39-1.414 0s-.39 1.023 0 1.414L10.586 12l-5.793 5.793c-.39.39-.39 1.023 0 1.414.195.195.45.293.707.293s.512-.098.707-.293L12 13.414l5.793 5.793c.195.195.45.293.707.293s.512-.098.707-.293c.39-.39.39-1.023 0-1.414L13.414 12z"
              ></path>
            </g>
          </svg>
        );
      case "delete":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M20.746 5.236h-3.75V4.25c0-1.24-1.01-2.25-2.25-2.25h-5.5c-1.24 0-2.25 1.01-2.25 2.25v.986h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h.368l1.583 13.262c.216 1.193 1.31 2.027 2.658 2.027h8.282c1.35 0 2.442-.834 2.664-2.072l1.577-13.217h.368c.414 0 .75-.336.75-.75s-.335-.75-.75-.75zM8.496 4.25c0-.413.337-.75.75-.75h5.5c.413 0 .75.337.75.75v.986h-7V4.25zm8.822 15.48c-.1.55-.664.795-1.18.795H7.854c-.517 0-1.083-.246-1.175-.75L5.126 6.735h13.74L17.32 19.732z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M10 17.75c.414 0 .75-.336.75-.75v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .414.336.75.75.75zm4 0c.414 0 .75-.336.75-.75v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .414.336.75.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "pin":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M20.472 14.738c-.388-1.808-2.24-3.517-3.908-4.246l-.474-4.307 1.344-2.016c.258-.387.28-.88.062-1.286-.218-.406-.64-.66-1.102-.66H7.54c-.46 0-.884.254-1.1.66-.22.407-.197.9.06 1.284l1.35 2.025-.42 4.3c-1.667.732-3.515 2.44-3.896 4.222-.066.267-.043.672.222 1.01.14.178.46.474 1.06.474h3.858l2.638 6.1c.12.273.39.45.688.45s.57-.177.688-.45l2.638-6.1h3.86c.6 0 .92-.297 1.058-.474.265-.34.288-.745.228-.988zM12 20.11l-1.692-3.912h3.384L12 20.11zm-6.896-5.413c.456-1.166 1.904-2.506 3.265-2.96l.46-.153.566-5.777-1.39-2.082h7.922l-1.39 2.08.637 5.78.456.153c1.355.45 2.796 1.78 3.264 2.96H5.104z"
              ></path>
            </g>
          </svg>
        );
      case "embed":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M23.804 11.5l-6.496-7.25c-.278-.31-.752-.334-1.06-.06-.308.277-.334.752-.058 1.06L22.238 12l-6.047 6.75c-.275.308-.25.782.06 1.06.142.127.32.19.5.19.204 0 .41-.084.558-.25l6.496-7.25c.252-.28.258-.713 0-1zm-23.606 0l6.496-7.25c.278-.31.752-.334 1.06-.06.308.277.334.752.058 1.06L1.764 12l6.047 6.75c.277.308.25.782-.057 1.06-.143.127-.322.19-.5.19-.206 0-.41-.084-.56-.25L.197 12.5c-.252-.28-.257-.713 0-1zm9.872 12c-.045 0-.09-.004-.135-.012-.407-.073-.68-.463-.605-.87l3.863-21.5c.074-.407.466-.674.87-.606.408.073.68.463.606.87l-3.864 21.5c-.065.363-.38.618-.737.618z"
              ></path>
            </g>
          </svg>
        );
      case "analytics":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 22c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v18.5c0 .414-.336.75-.75.75zm5.14 0c-.415 0-.75-.336-.75-.75V7.89c0-.415.335-.75.75-.75s.75.335.75.75v13.36c0 .414-.337.75-.75.75zM6.86 22c-.413 0-.75-.336-.75-.75V10.973c0-.414.337-.75.75-.75s.75.336.75.75V21.25c0 .414-.335.75-.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "edit":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="m7 17.013 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.583v4.43zM18.045 4.458l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58zM9 13.417l6.03-5.973 1.586 1.586-6.029 5.971L9 15.006v-1.589z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2z"
              ></path>
            </g>
          </svg>
        );
      case "plus":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.75 11H13V4.25c0-.553-.447-1-1-1s-1 .447-1 1V11H4.25c-.553 0-1 .447-1 1s.447 1 1 1H11v6.75c0 .553.447 1 1 1s1-.447 1-1V13h6.75c.553 0 1-.447 1-1s-.447-1-1-1z"
              ></path>
            </g>
          </svg>
        );
      case "topic":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12.003 23.274c-.083 0-.167-.014-.248-.042-.3-.105-.502-.39-.502-.708v-4.14c-2.08-.172-4.013-1.066-5.506-2.56-3.45-3.45-3.45-9.062 0-12.51s9.062-3.45 12.512 0c3.096 3.097 3.45 8.07.82 11.565l-6.49 8.112c-.146.182-.363.282-.587.282zm0-21.05c-1.882 0-3.763.717-5.195 2.15-2.864 2.863-2.864 7.524 0 10.39 1.388 1.387 3.233 2.15 5.195 2.15.414 0 .75.337.75.75v2.72l5.142-6.425c2.17-2.885 1.876-7.014-.696-9.587-1.434-1.43-3.316-2.148-5.197-2.148z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M15.55 8.7h-7.1c-.413 0-.75-.337-.75-.75s.337-.75.75-.75h7.1c.413 0 .75.335.75.75s-.337.75-.75.75zm-3.05 3.238H8.45c-.413 0-.75-.336-.75-.75s.337-.75.75-.75h4.05c.414 0 .75.336.75.75s-.336.75-.75.75z"
              ></path>
            </g>
          </svg>
        );
      case "twitterCircle":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M14.14 5.846c-.386-2.882-2.15-4.6-4.72-4.6s-4.336 1.722-4.72 4.6C4.144 10 5.776 11.6 9.42 11.6c3.648 0 5.28-1.6 4.72-5.754zM9.42 10.1c-2.68 0-3.677-.746-3.232-4.048.165-1.236.802-3.3 3.233-3.3V2.75c2.43 0 3.07 2.065 3.235 3.297.45 3.353-.605 4.053-3.234 4.053zm2.9 11.092c0-.414-.335-.75-.75-.75H3.218c-.39.012-.714-.294-.727-.683-.003-.085.01-.17.037-.248.722-2.9 3.646-5.126 7.515-4.9.41.014.76-.298.79-.707.024-.413-.293-.767-.706-.79-4.675-.253-8.174 2.494-9.055 6.038-.325 1.17.36 2.384 1.53 2.71.2.056.408.083.617.08h8.352c.413 0 .75-.336.75-.75v-.003.002zm9.427-7.469c-1.272-1.054-3.157-.878-4.212.394-.606-.733-1.525-1.133-2.474-1.08-1.648.095-2.908 1.508-2.814 3.156 0 3.373 3.876 6.78 5.3 6.807 1.397-.026 5.276-3.434 5.278-6.807.053-.948-.347-1.864-1.077-2.47zM17.565 21.5c-.72-.107-3.82-2.763-3.82-5.307-.012-.875.65-1.61 1.52-1.693.696 0 1.092.488 1.656 1.278.04.05.083.092.132.13.34.267.83.21 1.095-.13.565-.795.953-1.278 1.653-1.278.87.08 1.534.818 1.522 1.693 0 2.546-3.096 5.198-3.757 5.308z"
              ></path>
            </g>
          </svg>
        );
      case "logout":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M15.692 11.6l-5.14-5.14c-.292-.29-.767-.29-1.06 0s-.293.77 0 1.063l3.858 3.858H2.83c-.415 0-.75.337-.75.75s.335.75.75.75h10.52l-3.857 3.86c-.292.292-.292.767 0 1.06.147.146.34.22.53.22s.385-.073.53-.22l5.14-5.14c.293-.292.293-.766 0-1.06z"
              ></path>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M19.788 2.13H7.372c-1.264 0-2.292 1.03-2.292 2.293V7.38c0 .415.336.75.75.75s.75-.335.75-.75V4.424c0-.437.355-.792.792-.792h12.416c.437 0 .792.356.792.793V19.84c0 .436-.355.79-.792.79H7.372c-.437 0-.792-.354-.792-.79v-2.96c0-.413-.336-.75-.75-.75s-.75.337-.75.75v2.96c0 1.263 1.028 2.29 2.292 2.29h12.416c1.264 0 2.292-1.027 2.292-2.29V4.422c0-1.264-1.028-2.292-2.292-2.292z"
              ></path>
            </g>
          </svg>
        );
      case "info":
        return (
          <svg
            className={nameClass ? nameClass : ""}
            onClick={(e) => (handleClick ? handleClick(e) : "")}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <g>
              <path
                fill={fill ? fill : "#f1f1f1"}
                d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              ></path>
            </g>
          </svg>
        );
      default:
        return null;
    }
  };

  return <>{renderIcon(iconName)}</>;
};

export default IconSVG;
